<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "accordion",

        provide() {
            return {
                accordionState: this.sharedState
            }
        },
        data: function () {
            return {
                sharedState: {
                    active: null,
                }
            };
        },
    }
</script>
